<template>
  <div :class="`comp-xl-tabs comp-xl-tabs-${randomString}`">
    <div class="tabs-container" :class="{ 'tabs-container-width-type': widthType }">
      <div class="icon-page icon-page-left" v-if="configData.offset > 0">
        <jw-button type="text" class="icon-btn" status="normal" @click="scrollTab(false)">
          <template #icon>
            <qfei-icon-caret-left-outlined class="icon-outlined" />
          </template>
        </jw-button>
      </div>
      <draggable :class="`drag-container drag-container-scrollbar-hide  drag-${randomString}`" animation="200" :delay="100" itemKey="index" :force-fallback="true" @end="dragEnd" ghost-class="ghost-class" drag-class="drag-class" :list="formatTabs" filter=".forbid" handle=".mover">
        <template #item="{ element, index }">
          <div
            @click.stop="selectTab(element, true)"
            @dblclick.stop="editTab(element)"
            :class="{
              'tab-container': true,
              active: activeKey == element?.[formatFieldName?.key],
              'short-border': hasOptSlot && activeKey == element?.[formatFieldName?.key] && (!isAllowEdit || editInfo.key != element?.[formatFieldName?.key]),
              mover: isDrag && !editInfo.key
            }"
            :style="{
              fontSize: `${typeof fontSize === 'number' ? fontSize + 'px' : fontSize}`
            }"
          >
            <div class="tab-title" :style="{ boxSizing: 'content-box', width: `${element.width}px`, padding: `${globalCss.paddingTB}px  ${globalCss.paddingLR}px` }" :title="element?.[formatFieldName?.title]">
              <template v-if="element?.[formatFieldName?.icon]">
                <component class="tab-icon" :style="{ width: `${iconSize}px`, height: `${iconSize}px`, fontSize: `${iconSize}px` }" :is="element?.[formatFieldName?.icon]" />
              </template>
              <div :style="{ width: element.textWidth + 'px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }">
                <jw-input @blur.stop="changeTabName" @press-enter.stop="changeTabName" ref="inputRef" v-if="isAllowEdit && editInfo.key == element?.[formatFieldName?.key]" v-model="editInfo.value" :placeholder="$t('请输入')" />
                <template v-else>{{ element?.[formatFieldName?.title] }}</template>
              </div>
              <div class="slot-container" v-if="hasOptSlot && activeKey == element?.[formatFieldName?.key] && (!isAllowEdit || editInfo.key != element?.[formatFieldName?.key])">
                <slot :name="formatFieldName?.slotKey" :data="element" :index="index"> </slot>
              </div>
            </div>
          </div>
        </template>
      </draggable>
      <div class="icon-page icon-page-right" v-show="configData.clientWidth + configData.offset < configData.scrollWidth">
        <jw-button type="text" class="icon-btn" status="normal" @click="scrollTab(true)">
          <template #icon>
            <qfei-icon-caret-right-outlined class="icon-outlined" />
          </template>
        </jw-button>
      </div>
    </div>
    <jw-trigger position="br" :popup-offset="10" trigger="click" v-model:popup-visible="isAllPop" :popup-container="`.comp-xl-tabs-${randomString}`" :render-to-body="false">
      <jw-button type="text" class="view-all" v-show="configData.scrollWidth > configData.clientWidth">
        {{ $t('全部') }}
        <icon-down class="icon-dropdown" v-if="!isAllPop" />
        <icon-up class="icon-dropdown" v-else />
      </jw-button>
      <template #content>
        <div class="trigger-content">
          <jw-input v-model="searchKey" :placeholder="$t('搜索')" allow-clear />
          <div class="trigger-content-list">
            <div class="trigger-content-list-item" @click="userSelectTab(tab?.[formatFieldName?.key])" v-for="tab in formatTabs.filter((ft) => !searchKey || ft?.[fieldName?.title].includes(searchKey))" :key="tab?.[fieldName?.key]">
              <jw-tag class="item-tag">
                {{ tab?.[formatFieldName?.title] }}
              </jw-tag>
              <template v-if="activeKey == tab?.[formatFieldName?.key]">
                <icon-check-circle-fill class="icon-checked" />
              </template>
            </div>
          </div>
        </div>
      </template>
    </jw-trigger>
    <!-- 新增视图插槽 -->
    <slot name="extraAction"> </slot>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, nextTick, watch, computed, useSlots, onUnmounted } from 'vue';
import { QfeiIconCaretLeftOutlined, QfeiIconCaretRightOutlined } from '@qfei-design/icons-vue';
import { tools } from '@/utils/tools';
import draggable from 'vuedraggable';
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import { Message } from '@arco-design/web-vue';
const { t } = useI18n();
console.log(t('搜索'));
const slots = useSlots();
const isAllPop = ref(false);
const searchKey = ref(null);
const activeKey = ref(null);
const randomString = tools.randomString();
/**
 * tabs: [tab1, tab2]
 * tab: {
 *   title: 'tab名称',
 *   key: 'tab索引',
 *   icon: 'icon图标',
 *   slotKey: '插槽key'
 * }
 */
const props = defineProps({
  tabs: {
    type: Array,
    default: () => []
  },
  isDrag: {
    type: Boolean,
    default: false
  },
  fieldName: {
    type: Object,
    default: () => {
      return {};
    }
  },
  defaultActive: {
    type: [String, Number],
    default: null
  },
  fontSize: {
    type: [Number, String],
    default: 14
  },
  iconSize: {
    type: Number,
    default: 14
  },
  //是否允许进入编辑状态
  isAllowEdit: {
    type: Boolean,
    default: false
  },
  //是否显示激活tab的操作插槽
  hasOptSlot: {
    type: Boolean,
    default: false
  }
});
const emits = defineEmits(['selectTab', 'changeTab', 'viewSort', 'editTabName']);
const defaultFieldName = reactive({
  title: 'title',
  key: 'key',
  slotKey: 'slotKey',
  icon: 'icon'
});
const formatFieldName = computed(() => {
  //将默认值和用户传参合并，优先用户传参 兼容
  return { ...defaultFieldName, ...props.fieldName };
});
const editInfo = reactive({
  key: '',
  value: '',
  old: ''
});

// 滚动事件处理函数  添加条件判断确保只有在需要滚动的情况下才更新offset值
const handleScroll = () => {
  const dragElement = document.querySelector(`.drag-${randomString}`);
  if (dragElement) {
    if (configData.value.clientWidth < configData.value.scrollWidth) {
      // 是否补充50像素 slots?.extraAction !== undefined
      const pixel = slots?.extraAction !== undefined ? 50 : 0;
      configData.value.offset = dragElement.scrollLeft > 0 ? dragElement.scrollLeft + pixel : 0;
      console.log('configData-0', configData.value.offset);
    }
  }
};
onMounted(() => {
  computeTabWidth();
  // DOM加载完成 添加滚动事件监听
  const dragElement = document.querySelector(`.drag-${randomString}`);
  if (dragElement) {
    dragElement.addEventListener('scroll', handleScroll);
  }
});
// 监听组件卸载，移除滚动事件
onUnmounted(() => {
  const dragElement = document.querySelector(`.drag-${randomString}`);
  if (dragElement) {
    dragElement.removeEventListener('scroll', handleScroll);
  }
});
const globalCss = reactive({
  paddingLR: 10, //这个值要个css中.tab-title的padding左右相同
  paddingTB: 5,
  marginLR: 4,
  marginTB: 0,
  maxWidth: 140,
  computedMaxWidth: 140, //计算后的最大宽度 涉及图标 更多等显示时，重新计算宽度
  editInputWidth: 120 //编辑输入框宽度，要小于maxWidth
});
const configData = ref({
  offset: 0, //偏移量
  clientWidth: 0, //总宽度
  scrollWidth: 0 //滚动宽度
}); //配置信息
const formatTabs = ref([]);

const widthType = ref(false);

watch(
  () => props.tabs,
  () => {
    computeTabWidth();
  },
  { deep: true }
);
const computeTabWidth = (isInit = true) => {
  if (!props.tabs?.length) return false;
  /******** 计算宽度 start ***********/
  const _clientWidth = document.querySelector(`.comp-xl-tabs-${randomString}`)?.clientWidth || 0;
  configData.value.clientWidth = _clientWidth;
  /********* 计算宽度 end **********/
  const _tabs = _.cloneDeep(props.tabs);
  const fontSize = props.fontSize;
  // 有新增按钮时加50px
  let scrollWidth = slots?.extraAction !== undefined ? 50 : 0;
  const _activeKey = activeKey.value ? activeKey.value : props.defaultActive === null ? _tabs?.[0]?.[formatFieldName.value?.key] : props.defaultActive;
  activeKey.value = _activeKey;
  _tabs.forEach((_tab) => {
    if (!_tab?.[formatFieldName.value?.title]) {
      _tab[formatFieldName.value?.title] = `tabs${_tab?.[formatFieldName.value?.key]}`;
    }
    let _width = 0;
    if (props.isAllowEdit && editInfo.key == _tab?.[formatFieldName.value?.key]) {
      _width = globalCss.editInputWidth;
    } else {
      const ele = document.createElement('div');
      ele.style.opacity = '0';
      ele.style.position = 'absolute';
      ele.style.fontWeight = 'bold';
      ele.style.fontSize = typeof fontSize === 'number' ? `${fontSize}px` : `${fontSize}`;
      ele.style.whiteSpace = 'nowrap';
      ele.innerHTML = _tab?.[formatFieldName.value?.title];

      document.body?.appendChild?.(ele);
      //浏览器兼容 弥补1像素
      _width = 1 + Math.ceil(ele.getBoundingClientRect()?.width);
      document.body.removeChild(ele);
    }

    if (_width > globalCss.maxWidth) {
      _width = globalCss.maxWidth;
    }
    _tab['textWidth'] = _width;

    if (props.hasOptSlot && _activeKey == _tab?.[formatFieldName.value?.key] && (!props.isAllowEdit || editInfo.key != _tab?.[formatFieldName.value?.key])) {
      _width += 24;
    }
    //如果有图标，则预留图标位置
    if (_tab?.[formatFieldName.value?.icon]) {
      _width += props.iconSize + 4;
    }
    _tab['width'] = _width;
    _width = _width + globalCss.paddingLR * 2;
    scrollWidth += _width;
  });
  configData.value.scrollWidth = scrollWidth;
  formatTabs.value = _tabs;
  widthType.value = scrollWidth > _clientWidth;

  if (scrollWidth > _clientWidth) {
    console.log('scrollWidth', scrollWidth, _clientWidth);
    //需要滚动，那么就会显示全部按钮，重新计算宽度
    nextTick(() => {
      //500ms延迟 防止页面dom渲染未完成
      setTimeout(() => {
        configData.value.clientWidth = document.querySelector(`.drag-${randomString}`)?.clientWidth;
        if (isInit) {
          userSelectTab(activeKey.value, true);
        }
      }, 500);
    });
  } else {
    document.querySelector(`.drag-${randomString}`).scrollLeft = 0;
    configData.value.offset = 0;
  }
};

const scrollTab = (isRight) => {
  const queryDom = document.querySelector(`.drag-${randomString}`);
  const ave = configData.value.scrollWidth / formatTabs.value.length;
  const _scrollWidthAve = Math.floor(configData.value.clientWidth / ave) * ave;
  const _scrollLeft = queryDom.scrollLeft;
  let _scrollRes = 0;
  if (isRight) {
    if (configData.value.clientWidth + _scrollLeft + _scrollWidthAve >= configData.value.scrollWidth) {
      // 直接滚动到右侧
      _scrollRes = configData.value.scrollWidth - configData.value.clientWidth;
      console.log('configData-2', JSON.parse(JSON.stringify(configData.value)));
    } else {
      // 连续滚动到右侧
      _scrollRes = _scrollLeft + _scrollWidthAve;
    }
  } else {
    if (_scrollLeft - _scrollWidthAve <= 0) {
      // 直接滚动到左侧
      _scrollRes = 0;
    } else {
      // 连续滚动到左侧
      _scrollRes = _scrollLeft - _scrollWidthAve;
    }
  }
  _scrollRes = Math.ceil(_scrollRes);
  if (_scrollRes < 20) {
    _scrollRes = 0;
  }
  scrollTabPx(_scrollRes);
};
//获取元素左侧所有tab宽度
const getLeftWidth = (index, reduce = true) => {
  let _w = 0;
  formatTabs.value.forEach((ft, i) => {
    if (i < index && ft?.width) {
      _w += ft?.width;
      _w += globalCss.paddingLR * 2;
    }
  });
  if (index !== 0 && reduce) {
    _w = _w > 45 ? _w - 45 : 0;
  }

  return _w;
};
const selectDropTab = (index) => {
  const _w = getLeftWidth(index);
  scrollTabPx(_w);
  selectTab(formatTabs.value[index]);
};
const scrollTabPx = (_w) => {
  if (configData.value.clientWidth < configData.value.scrollWidth) {
    document.querySelector(`.drag-${randomString}`).scrollLeft = _w;
    configData.value.offset = _w;
    console.log('configData-1', _w);
  }
};
const selectTab = (ele, isNeedScroll = false) => {
  if (activeKey.value == ele?.[formatFieldName.value?.key]) return false;
  activeKey.value = ele?.[formatFieldName.value?.key];
  computeTabWidth(false);
  //判断是否需要滚动
  if (isNeedScroll) {
    //左侧箭头显示
    const _index = formatTabs.value.findIndex((tab) => tab?.[formatFieldName.value?.key] == ele?.[formatFieldName.value?.key]);
    const _w = getLeftWidth(_index, false); //tab前所有tab宽度
    const _nextW = getLeftWidth(_index); //即将要滚动到这里
    const _selfWidth = formatTabs.value[_index]?.width + globalCss.paddingLR * 2;
    if (configData.value.offset > _w && _nextW > _w && configData.value.offset > 0) {
      scrollTabPx(getLeftWidth(_index));
    }
    if (_w - configData.value.offset + +_selfWidth > configData.value.clientWidth) {
      scrollTabPx(getLeftWidth(_index));
    }
  }
  emits('selectTab', ele?.[formatFieldName.value?.key]);
};
const dragEnd = (e) => {
  if (e?.newDraggableIndex == e?.oldDraggableIndex) return;
  emits('changeTab', {
    tabs: formatTabs.value,
    activeKey: activeKey.value,
    point: formatTabs.value[e?.newDraggableIndex]?.id
  });
};
const userSelectTab = (key, isForce = false) => {
  isAllPop.value = false;
  if (key == activeKey.value && !isForce) return false;
  const _findIndex = formatTabs.value?.findIndex((tab) => tab?.[formatFieldName.value?.key] == key);
  if (_findIndex > -1) selectDropTab(_findIndex);
};
/********** 快捷编辑相关 start *************/
const inputRef = ref();
const setEditInfo = (info) => {
  if (!props.isAllowEdit || !props.hasOptSlot) return;
  editInfo.key = info?.[formatFieldName.value?.key];
  editInfo.value = info?.[formatFieldName.value?.title];
  editInfo.old = info?.[formatFieldName.value?.title];
  computeTabWidth(false);
  nextTick(() => {
    inputRef.value?.focus?.();
  });
};
const editTab = (info) => {
  if (activeKey.value !== info?.[formatFieldName.value?.key]) return;
  console.log(info, 'console.log(info');
  setEditInfo(info);
};
const changeTabName = ({ target }) => {
  const _editInfo = _.cloneDeep(editInfo);
  //赋值清空，不然影响计算
  editInfo.key = '';
  editInfo.value = '';
  editInfo.old = '';
  computeTabWidth(false);
  if (_editInfo.key === '') {
    return;
  }
  if (_editInfo.value === '') {
    Message.warning(t('请输入视图名称'));
    return;
  }
  if (target.value != _editInfo.old) {
    emits('changeTabName', {
      [formatFieldName.value?.key]: _editInfo.key,
      [formatFieldName.value?.title]: target.value
    });
  }
  // const _findIndex = formatTabs.value?.findIndex((tab) => tab?.[formatFieldName.value?.key] == _editInfo.key);
  // console.log(_findIndex, _editInfo, 'console.log(_findIndex, _editInfo')
  // if (_findIndex > -1) {
  //   formatTabs.value[_findIndex][formatFieldName.value?.title] = target.value;
  //   computeTabWidth(false);
  // }
};
/********** 快捷编辑相关 end *************/
eventListener('resize', computeTabWidth);
defineExpose({
  userSelectTab,
  setEditInfo
});
</script>
<style scoped lang="less">
@import './xl-tabs.less';
</style>
